import { IContent } from 'models/content.model';

import ProposalType from './proposal-type.enum';

export const content: IContent = {
  nl: {
    page: {
      [ProposalType.Zapper]: {
        title: 'Voor de altijd zenders-zapper',
        text: "Omdat jij graag lekker op de bank zit en langs verschillende zenders zapt, hebben we het volgende voorstel voor je. Bekijk 'm rustig voordat je beslist.",
      },
      [ProposalType.Streamer]: {
        title: 'Voor de altijd series-kijker',
        text: "Omdat jij graag een lekkere serie of film streamt, hebben we het volgende voorstel voor je. Bekijk 'm rustig voordat je beslist.",
      },
      [ProposalType.AltijdAlles]: {
        title: 'Voor de altijd alles-kijker',
        text: 'Filmpje kijken op Disney+ of gewoon lekker zappen op de bank?. Met dit speciale voorstel voor jou, kan het allemaal.',
      },
    },
    proposals: {
      disney: {
        title: 'Disney+ met reclame #{months} maanden gratis',
        text: `
          Binge alert: 3 maanden Disney+ met reclame gratis.
          <br>
          Van nieuwe hits tot tijdloze klassiekers, allemaal binnen handbereik.`,
        cta: 'Check deze deal',
      },
      film1: {
        title: 'Film1 #{months} maanden gratis',
        text: `
          Pak de popcorn erbij
          </br> 
          Met Film1 kijk je 3 maanden onbeperkt, waar en wanneer je wilt. Gratis en zonder reclame.`,
        cta: 'Check deze deal',
      },
      tvChannel: {
        title: 'TV Zender+ #{months} maanden gratis',
        text: `
          Meer zenders, meer plezier
          </br>
          Probeer TV Zender + nu #{months} maanden gratis en krijg toegang tot 35+ extra zenders vol entertainment, sport, kids en nog veel meer.`,
        cta: 'Check deze deal',
      },
      discount: {
        title: '#{months} maanden €#{price} korting op je factuur',
        text: `
        Liever korting? Dat kan ook
        </br> 
        #{months} maanden €#{price} korting op je factuur. Niet streamen, wel besparen.`,
        cta: 'Check deze deal',
      },
    },
    escape: {
      text: 'De oplossing spreekt mij niet aan. Klik',
      linkText: 'hier',
      modal: {
        title: 'We vinden het jammer dat onze voorstellen je niet aanspreken',
        content:
          'Vind je geen van de oplossingen passend? We denken graag met je mee. Bel ons op <a href="tel:09001884">0900 - 1884</a> of <a href="tel:1200">1200</a> vanaf je Ziggo-lijn. We staan voor je klaar.',
      },
    },
  },
  en: {},
};
